import { gql, useQuery } from '@apollo/client';

export const GET_PAYROLL_ACCOUNTING = gql`
  query getPayrollAccounting($filter: FilterPayrollAccountingInput!) {
    getPayrollAccounting(filter: $filter) {
      _id
      item {
        _id
        companyId
        type
        softwareTarget
        createdBy
        date
        softwareTarget
        fileId
        status
        memberCount
        file {
          location
          filename
          _id
        }
      }
    }
  }
`;

interface IFilter {
  parentCompanyId?: string;
  datevNumberId?: string;
  companyId?: string;
  payrollAccountingSettingId?: string;
  year?: number;
}

export const useGetPayrollAccounting = ({
  filter,
}: {
  filter?: IFilter;
} = {}) => {
  const { companyId, datevNumberId, parentCompanyId } = filter || {};
  const { data, loading } = useQuery(GET_PAYROLL_ACCOUNTING, {
    variables: {
      filter,
    },
    skip: !parentCompanyId || !companyId || !datevNumberId,
    fetchPolicy: 'no-cache',
  });

  return { collection: data?.getPayrollAccounting || [], loading };
};
